import React, { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import { ETranslation } from "../../../translations/translation-keys";
import Button, { EButtonColor } from "../Button/Button";
import ModalBody from "../Modal/ModalBody/ModalBody";
import ModalFooter from "../Modal/ModalFooter/ModalFooter";

interface IProps {
  body?: ReactNode;
  onConfirm: () => void;
  onCancel: () => void;
}

const ConfirmDialog: React.FC<IProps> = ({ body, onConfirm, onCancel }) => {
  const { t } = useTranslation();
  return (
    <>
      <ModalBody>
        <div style={{ color: '#334155', fontSize: '0.975rem', lineHeight: '1.6' }}>
          {body}
        </div>
      </ModalBody>
      <ModalFooter>
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '0.75rem', marginTop: '0.5rem', width: '100%' }}>
          <Button 
            onClick={onCancel} 
            color={EButtonColor.NONE}
            style={{ 
              backgroundColor: '#f1f5f9', 
              color: '#475569', 
              border: '1px solid #e2e8f0', 
              fontWeight: 600, 
              borderRadius: '6px',
              padding: '0.6rem 1.5rem',
              transition: 'all 0.15s ease-in-out'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#e2e8f0';
              e.currentTarget.style.color = '#1e293b';
              e.currentTarget.style.transform = 'scale(1.02)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#f1f5f9';
              e.currentTarget.style.color = '#475569';
              e.currentTarget.style.transform = '';
            }}
          >
            {t(ETranslation.COMMON_NO)}
          </Button>
          <Button 
            onClick={onConfirm}
            style={{ 
              fontWeight: 600, 
              borderRadius: '6px',
              padding: '0.6rem 1.5rem',
              boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
              transition: 'all 0.15s ease-in-out'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#d94723';
              e.currentTarget.style.transform = 'scale(1.02)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '';
              e.currentTarget.style.transform = '';
            }}
          >
            {t(ETranslation.COMMON_YES)}
          </Button>
        </div>
      </ModalFooter>
    </>
  );
}

export default ConfirmDialog;
